// sw-register.ts — register service worker once per page load.
// 失敗吞掉：SW 不可用時頁面正常運作；register() 對既已註冊的 SW 是 idempotent。

document.addEventListener("DOMContentLoaded", () => {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.register("/sw.js").catch(() => {
    // intentional no-op
  });
});
